import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { SNACKBAR_ALERT_TYPES } from '../../../core/constants/snackbar-alert-types.enum';

@Component({
    selector: 'app-snackbar-alerts',
    templateUrl: './snackbar-alerts.component.html',
    styleUrls: ['./snackbar-alerts.component.css']
})
export class SnackbarAlertsComponent implements OnInit {
    successSnackbarAlert = SNACKBAR_ALERT_TYPES.SUCCESS;
    errorSnackbarAlert = SNACKBAR_ALERT_TYPES.ERROR;

    constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {}

    ngOnInit(): void {}
}
